import React from 'react';
import cx from 'classnames';

import styles from './Banner.module.scss';

export type BannerProps = {
  icon?: React.ReactNode;
  level?: string | 'info' | 'warning' | 'error' | 'success';
};

const Banner: React.FC<BannerProps> = ({ children, icon, level = 'info' }) => (
  <div className={cx(styles.banner, { [styles['banner__' + level]]: level })}>
    {icon && <div className={styles['banner__icon']}>{icon}</div>}
    <div className={styles['banner__content']}>{children}</div>
  </div>
);

export { Banner };
